export const REDIRECT = '/account-access/:docId'
export const HOME = '/dashboard/'
export const PAY_BILL = '/dashboard/pay-bills'
export const MANAGE_BILL = '/dashboard/manage-bills'
export const TRANSFER = '/dashboard/transfer-funds'
export const INVEST = '/dashboard/investments'
export const INVESTNEW = '/dashboard/investments/new'

export const BENEFICIARIES = '/dashboard/beneficiaries'
export const TRANSACTION_HISTORY = '/dashboard/transaction-history'
export const TRANSACTION_STATMENT = '/dashboard/account-statement'
export const ACCOUNT_SETTINGS = '/dashboard/account-settings'



